import KitService from "../../services/kit-service"
import { makeKitResource } from "../resources/kit-resource-factory"

export const makeKitService = (): KitService => {
    return new KitService(makeKitResource())
}
